var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBallPositionBorder1X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "36px",
    viewBox: "0 0 29 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CDFEDC6F-D965-4680-99D7-4C1A8EDDBB34@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stats---Game",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1-Stats---Play-Entry---D",
    transform: "translate(-761.000000, -119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scoreboard-/-field-/-1.0-main",
    transform: "translate(120.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(641.379747, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ball-position",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48123912,3.24506603 L27.2839816,3.24506603 C29.4931206,3.24506603 31.2839816,5.03592704 31.2839816,7.24506603 L31.2839816,27.245066 C31.2839816,29.454205 29.4931206,31.245066 27.2839816,31.245066 L8.48123912,31.245066 C7.19988892,31.245066 5.99609596,30.6312027 5.24362111,29.5940721 L-2.86387504,18.4195691 C-3.3721297,17.7190454 -3.3721297,16.7710867 -2.86387504,16.070563 L5.24362111,4.89605995 C5.99609596,3.85892933 7.19988892,3.24506603 8.48123912,3.24506603 Z",
    id: "Container",
    fill: "#FFFFFF",
    stroke: "#202D43",
    transform: "translate(14.000000, 17.245066) rotate(-90.000000) translate(-14.000000, -17.245066) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2710964,27.2781636 L16.2710964,32.6440517 C16.2710964,33.1963364 15.8233811,33.6440517 15.2710964,33.6440517 C14.9533779,33.6440517 14.6545651,33.4930712 14.4660785,33.2373022 L12.4889077,30.5543581 C12.2289316,30.2015806 12.2289316,29.7206346 12.4889077,29.3678571 L14.4660785,26.6849131 C14.7937217,26.240314 15.4197478,26.1455025 15.8643469,26.4731457 C16.120116,26.6616323 16.2710964,26.9604451 16.2710964,27.2781636 Z",
    id: "Arrow",
    fill: "#202D43",
    transform: "translate(14.271096, 29.961084) rotate(-90.000000) translate(-14.271096, -29.961084) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallPositionBorder1X);
export default __webpack_public_path__ + "static/media/ball-position-border@1x.e3abca121a1ea61c4b936b5e55b625c8.svg";
export { ForwardRef as ReactComponent };